/**
 * AI Settings Hook
 * 
 * Provides AI provider settings and configuration management.
 */

export interface AISettings {
  provider: 'anthropic' | 'openai';
  model: string;
  temperature: number;
  maxTokens: number;
  apiKey?: string;
  enabled: boolean;
  systemPrompt?: string;
  initialMessage?: string;
  resources?: AIResource[];
}

export interface AIResource {
  id: string;
  name: string;
  content: string;
  type: 'document' | 'website' | 'api' | 'link' | 'pdf';
  url?: string;
  description?: string;
  dateAdded?: string;
}

export interface ProviderConfig {
  id: string;
  name: string;
  requiresApiKey: boolean;
  models: string[];
}

export function useAISettings() {
  return {
    settings: {
      provider: 'anthropic' as const,
      model: 'claude-3-5-sonnet-20241022',
      temperature: 0.7,
      maxTokens: 4096,
      apiKey: '',
      enabled: false,
      systemPrompt: '',
      initialMessage: '',
      resources: [] as AIResource[],
    },
    updateSettings: (_settings: Partial<AISettings>) => {
      console.warn('useAISettings.updateSettings is not implemented yet');
    },
    addResource: (_resource: AIResource) => {
      console.warn('useAISettings.addResource is not implemented yet');
    },
    removeResource: (_id: string) => {
      console.warn('useAISettings.removeResource is not implemented yet');
    },
    isLoading: false,
  };
}

export const availableProviders: ProviderConfig[] = [
  { 
    id: 'anthropic', 
    name: 'Anthropic (Claude)', 
    requiresApiKey: true,
    models: ['claude-3-5-sonnet-20241022', 'claude-3-opus-20240229']
  },
  { 
    id: 'openai', 
    name: 'OpenAI (GPT)', 
    requiresApiKey: true,
    models: ['gpt-4', 'gpt-3.5-turbo']
  },
];

export type Resource = AIResource;
